export default {
    methods: {
        incrementCurrent: function(variable) {
            this.$store.commit('app/incrementCurrent', variable)
        },
        decrementCurrent: function(variable) {
            this.$store.commit('app/decrementCurrent', variable)
        },
        setSection: function(section) {
            this.$store.commit('app/setCurrentSection', section)
        },
        resetStep: function() {
            this.$store.commit('app/setCurrentStep', 0)
        },
        setSectionCompleted: function(section) {
            this.$store.commit('app/setSectionCompleted', section)
        },
        setSectionTitle: function(section) {
            this.$store.commit('app/setsectionTitle', section)
        },
        setChapterIntro: function(variable) {
            this.$store.commit('app/setChapterIntro', variable)
        },
        setActiveQuestionStep: function(variable) {
            this.$store.commit('app/setActiveQuestionStep', variable)
        }
    }
}
